import { apiClient } from '@/utils/api-client';
import type { ApiResponse, JsonApiResource } from '@/types/api';

export interface ResponseReview {
  id: string;
  review_status: 'pending' | 'reviewed' | 'resolved' | 'dismissed';
  review_category: 'accuracy' | 'relevance' | 'tone' | 'terminology' | 'other' | null;
  reviewer_notes: string | null;
  severity: 'low' | 'medium' | 'high' | null;
  reviewed_by: string | null;
  reviewed_at: string | null;
  converted_to_eval_case_id: string | null;
  user_message: string | null;
  assistant_message: string | null;
  user_feedback: string | null;
  helpful_flag: boolean | null;
  session_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface ReviewUpdateData {
  review_status?: ResponseReview['review_status'];
  review_category?: ResponseReview['review_category'];
  reviewer_notes?: string;
  severity?: ResponseReview['severity'];
  reviewed_by?: string;
}

export const reviewQueueService = {
  async list(params?: { status?: string; severity?: string; category?: string }): Promise<ApiResponse<JsonApiResource<ResponseReview>[]>> {
    const queryParams: Record<string, string> = {};
    if (params?.status) queryParams.status = params.status;
    if (params?.severity) queryParams.severity = params.severity;
    if (params?.category) queryParams.category = params.category;
    return apiClient.get('/api/admin/response_reviews', queryParams);
  },

  async get(id: string): Promise<ApiResponse<JsonApiResource<ResponseReview>>> {
    return apiClient.get(`/api/admin/response_reviews/${id}`);
  },

  async update(id: string, data: ReviewUpdateData): Promise<ApiResponse<JsonApiResource<ResponseReview>>> {
    return apiClient.patch(`/api/admin/response_reviews/${id}`, { response_review: data });
  },

  async sync(): Promise<{ synced_count: number }> {
    return apiClient.post('/api/admin/response_reviews/sync');
  },

  async convertToEval(id: string): Promise<{ eval_case_id: string }> {
    return apiClient.post(`/api/admin/response_reviews/${id}/convert_to_eval`);
  },
};
